
export const dateReadableFormat = (date: string | Date) => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
  const _date = new Date(date);
  const year = _date.getFullYear() === new Date().getFullYear() ? '' : `, ${_date.getFullYear()}`;
  return `${_date.getDate()} ${monthNames[_date.getMonth()]} ${year}`;
};


export const timeFormatAMPM = (date: string | Date) => {
  const _date = new Date(date);
  var hours = _date.getHours();
  var minutes = _date.getMinutes();
  var ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  let nminutes = minutes < 10 ? '0' + minutes : minutes;
  var strTime = hours + ':' + nminutes + ampm;

  return `${dateReadableFormat(date)} | ${strTime}`;
};